module.exports = __webpack_public_path__ + "media/packs/images/state/canceled-9158cec2b909239374f47276874b2415.svg";